import { jsx as _jsx } from "react/jsx-runtime";
import { Tm1Icon } from '@tm1/design-system-react';
export const ToggleArrow = (props) => {
    const { open, closedIcon, openedIcon } = props;
    const dataTestid = props['data-testid'];
    return open ? (_jsx(Tm1Icon, { size: "small", icon: openedIcon || 'down', "data-testid": dataTestid })) : (_jsx(Tm1Icon, { size: "small", icon: closedIcon || 'forward', "data-testid": dataTestid }));
};
